import z from 'zod';

import { WorkflowErrorCode } from './constants';

const errorExtensionSchema = z.object({
  extensions: z.object({
    message: z.string(),
  }),
});

const errorCodeSchema = z
  .object({
    errors: z.array(errorExtensionSchema).nonempty(),
  })
  .transform((obj) => obj.errors[0].extensions.message);

export function isSupportedWorkflowErrorCode(code: string) {
  return WorkflowErrorCode.safeParse(code).success;
}

/**
 * use to extract error code from ApolloError
 */
export function getWorkflowErrorCode(error: unknown) {
  try {
    const code = errorCodeSchema.parse(error);

    return WorkflowErrorCode.parse(code);
  } catch {
    return undefined;
  }
}
